// Tab/Shift+Tab cycling confined to an AppDialog's Panel — or a Modal's
// Window (the same trap since 2026-09-26: Tab left CreateAgentModal for the
// page behind, and Escape then did nothing, found by ws-w2). `this` is the
// panel element (called from its own `onKeydown`). Deliberately NOT
// implemented via `inert` on the rest of the page — a recorded trap in this
// codebase: `pointer-events: none` on an inert background silences the
// layer's OWN `mouseenter`/dismiss escape hatches too, so an inert-based
// trap can leave the dialog impossible to close by mouse. A scoped
// Tab-cycle over the panel's own focusable descendants gets the same
// keyboard containment without touching anything outside the panel.
export function appDialogTrapTab(e) {
  if (!e || e.key !== 'Tab') return
  const el = this
  if (!el.node || typeof document === 'undefined') return
  // The selector names candidate KINDS; tabbability is decided in the filter,
  // for EVERY candidate. A roving-tabindex member — an ARIA tablist's inactive
  // tab, `role=tab tabindex="-1"` — matches `button:not([disabled])`, but the
  // native Tab order never stops on it: counting it as first/last makes
  // `active === last` unreachable at the true native-last control, and Tab
  // leaks past the panel (APPDIALOG-TRAPTAB-LEAKS-PAST-ROVING-TABINDEX-TABLIST-1,
  // found live on the CRM contact detail panel). The `tabIndex` PROPERTY, not
  // the attribute: it resolves defaults and invalid values the way the
  // browser's own tab order does, and a harness stand-in without it
  // (`undefined < 0` is false) stays tabbable.
  const nodeList = el.node.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]'
  )
  const focusable = Array.prototype.filter.call(
    nodeList,
    (n) => n.offsetParent !== null && !(n.tabIndex < 0)
  )
  if (!focusable.length) return
  const first = focusable[0]
  const last = focusable[focusable.length - 1]
  const active = document.activeElement
  // Focus on the PANEL ITSELF (a side panel's `initialFocus: 'panel'`, the
  // Modal window its manageFocus lands on): Shift+Tab from there went to
  // whatever precedes the panel in the document — the page behind. From the
  // panel (or from anywhere not inside it) both directions enter the cycle.
  const atPanel =
    active === el.node || (typeof el.node.contains === 'function' && !el.node.contains(active))
  if (e.shiftKey && (active === first || atPanel)) {
    e.preventDefault()
    last.focus()
  } else if (!e.shiftKey && (active === last || atPanel)) {
    e.preventDefault()
    first.focus()
  }
}
